import { render, staticRenderFns } from "./BtMetricsModel.vue?vue&type=template&id=38ca1c56&"
import script from "./BtMetricsModel.vue?vue&type=script&lang=js&"
export * from "./BtMetricsModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports